export default "__VITE_ASSET__DUnLF62p__"